




















import Vue from 'vue'

const { Splitpanes, Pane } = require('splitpanes')
import 'splitpanes/dist/splitpanes.css'
export default Vue.extend({
  components: { Splitpanes, Pane },
})
